// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/CloseButton/CloseButton.sass
// module id = 238
// module chunks = 0